import {TheRave} from "../TheRave";
import {TheRaveScatterSymbol} from "../symbol/TheRaveScatterSymbol";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {TheRaveGameMode} from "../gameflow/TheRaveGameMode";

export class ScatterController extends PIXI.Container {
    private _scatterNum: number = 0;
    private _scatters: TheRaveScatterSymbol[] = [];
    private _scatterContainers: (PIXI.Container|null)[] = [];

    constructor() {
        super();
    }

    public playScatterLandingAnimation(reel: number, symId: number, symbol: TheRaveScatterSymbol, skip:boolean): void {
        this._scatters.push(symbol);
        this._scatterContainers.push(symbol.animationContainer);
        const isLastReel: boolean = reel === 4,
            scattersNum: number = this._scatters.length;
        TheRave.enhancerReels[reel].reelView.setPosition(symId);
        symbol.playLanding(false, scattersNum);

        if (scattersNum === TheRave.model.startNearWinAtScatterCount && !isLastReel && !skip) {
            TheRave.nearwinPresentation.start(reel + 1, true);
        }
        if(TheRave.model.isFreespin){
            if(TheRave.model.parsedGameData.scattersNumInFs === 1){
                TheRave.fsPlus.play(symbol, TheRave.model.nextMode === TheRaveGameMode.FREESPIN_SUPER?2:1);
                TheRave.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedGameData.freespinsLeft);
            }else if(TheRave.model.parsedGameData.scattersNumInFs === 2){
                if (scattersNum === 1) {
                    TheRave.fsPlus.play(symbol, 1);
                    TheRave.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedGameData.freespinsLeft-2);
                }else{
                    TheRave.fsPlus.play(symbol, 2);
                    TheRave.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedGameData.freespinsLeft);
                }
            }
        }else if (scattersNum >= 2) {
            this._scatters.forEach((sym: TheRaveScatterSymbol) => {
                if (!NolimitConfig.isDevMode) {
                    if (sym.symbolName !== "S") {
                        Logger.logDev("no scatter error log", TheRave.model.reels);
                        //throw new Error("Error: Symbol is not scatter on scatter pos" + TheRave.model.reels);
                    }
                }

                if(sym && sym.symbolName === "S" && sym.playEnhancerFrame) {
                    sym.playEnhancerFrame();
                    TheRave.background.playShakeEffect();
                }
            });
        }
    }


    public reset(): void {
        this._scatterNum = 0;
        this._scatters = [];
    }

    public removeScatterAnimations():void{
        (<PIXI.Container[]>this._scatterContainers).forEach((container:PIXI.Container)=>{
            if(container){
                TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)!.removeChild(container);
            }});
        this._scatterContainers = [];
    }

    public onRestore(): void {

    }

}